/* grid.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
            <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            <g>
                <circle class="foreground-gl" cx="1.4" cy="1.4" r="1.4"/>
                <circle class="foreground-gl" cx="1.4" cy="10.2" r="1.4"/>
                <circle class="foreground-gl" cx="1.4" cy="5.8" r="1.4"/>
                <circle class="foreground-gl" cx="1.4" cy="14.6" r="1.4"/>
                <circle class="foreground-gl" cx="14.6" cy="1.4" r="1.4"/>
                <circle class="foreground-gl" cx="14.6" cy="10.2" r="1.4"/>
                <circle class="foreground-gl" cx="14.6" cy="5.8" r="1.4"/>
                <circle class="foreground-gl" cx="14.6" cy="14.6" r="1.4"/>
                <circle class="foreground-gl" cx="5.8" cy="1.4" r="1.4"/>
                <circle class="foreground-gl" cx="5.8" cy="10.2" r="1.4"/>
                <circle class="foreground-gl" cx="5.8" cy="5.8" r="1.4"/>
                <circle class="foreground-gl" cx="5.8" cy="14.6" r="1.4"/>
                <circle class="foreground-gl" cx="10.2" cy="1.4" r="1.4"/>
                <circle class="foreground-gl" cx="10.2" cy="10.2" r="1.4"/>
                <circle class="foreground-gl" cx="10.2" cy="5.8" r="1.4"/>
                <circle class="foreground-gl" cx="10.2" cy="14.6" r="1.4"/>
            </g>
            </svg>
         `,
};
